// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-form-generator .field-checkbox input[data-v-f199f47a]{margin-left:12px}", "",{"version":3,"sources":["webpack://./src/components/Widgets/FormGenerator/fields/core/fieldCheckbox.vue"],"names":[],"mappings":"AACA,2DACC,gBAAA","sourcesContent":["\n.vue-form-generator .field-checkbox input {\n\tmargin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
